<app-dialog [config]="dialogConfig"
            (onApply)="onApplyE.emit($event)"
            (onClose)="onCloseE.emit($event)"></app-dialog>
